import React from 'react';
function LargeCheckbox({ obj, id, checked, onChange }) {
  return (
    <div className="lg-checkbox">
      <img className="lg-checkbox-logo" src={obj.image.url} alt={obj.image.alt} />
      <div className="lg-checkbox-heading checkbox-container">
        <input className="box" id={id} type="checkbox" name={obj.name} value={obj.name} checked={checked} onChange={onChange} />
        <label className="lg-checkbox-heading-text" htmlFor={id}>{obj.name}</label>
      </div>
      <div>
        <p className="lg-checkbox-copy">{obj.opt_in_copy}</p>
      </div>
    </div>
  );
}
export default LargeCheckbox;
